module.exports = __webpack_public_path__ + "bRIe_XFrtjaX0I2nF/RDC_RED_Logo_House.svg";